import { gql } from '@apollo/client'

const ADD_NEW_PATIENT_TAGS = gql`
  mutation ADD_NEW_PATIENT_TAGS(
    $generatedID: ID!
    $name: String!
    $order: Int
    $color: String!
    $icon: String
    $nextTags: [ID]
    $forQrCode: Boolean
    $forWhatsApp: Boolean
  ) {
    addNewPatientTags(
      generatedID: $generatedID
      name: $name
      order: $order
      color: $color
      icon: $icon
      nextTags: $nextTags
      forQrCode: $forQrCode
      forWhatsApp: $forWhatsApp
    ) {
      id
      name
      order
      color
      icon
      hasNextTags
      forQrCode
      forWhatsApp
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      nextTags {
        id
        name
        color
      }
    }
  }
`

export default ADD_NEW_PATIENT_TAGS
